import React from 'react';
// Zustand
import { useStore } from '../../zustand';
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { header_default_styles } from "../../assets/jss/headerStyles";

const useStyles = makeStyles(header_default_styles);

export default function Header() {
    const { vList } = useStore.getState().variants_payload;
    const variant_id = useStore(state => state.variant_id);
    const classes = useStyles();

    return (
        <div className={classes.header}>
            <div className={classes.header_wrapper}>
                <section>
                    <h1 className={classes.variantTitle}>{vList[variant_id].title}</h1>
                    { vList[variant_id].subTitle !== "Default Title" &&  
                    <section className={classes.optionsBlock}>
                        <h3 className={classes.optionsText}>{vList[variant_id].subTitle}</h3>
                    </section>
                    }
                </section>
            </div>
        </div>
    );
}